import { styleConstants } from '@paywithextend/components'
import React from 'react'
import ActionRightFlyoutContent from 'src/components/ActionRightFlyoutContent/ActionRightFlyoutContent'
import AutomationRuleForm from 'src/components/AutomationRuleForm/AutomationRuleForm'
import LoadingBackgroundPage from 'src/components/LoadingBackgroundPage/LoadingBackgroundPage'
import NotFoundRightFlyoutContent from 'src/components/NotFoundRightFlyoutContent/NotFoundRightFlyoutContent'
import RightFlyout, {
  RightFlyoutBodyWidths,
} from 'src/components/RightFlyout/RightFlyout'
import SvgLightningBolt from 'src/components/Svgs/SvgLightningBolt'
import { ImageNames } from 'src/enums'
import { useBackgroundDispatch } from 'src/hooks'
import { useColorOrGrayscaleImage } from 'src/hooks/brandHooks'
import Trns from 'src/localization/Trns'
import { closeModal } from 'src/navigation/Lnk'
import {
  PostAutomationRuleRequest,
  usePostAutomationRule,
} from 'src/queries/organizations/automationRules.queries'
import { useQueryOwnUser } from 'src/queries/users.queries'
import { css } from 'styled-components'

const CreateAutomationRule: React.FC = () => {
  const dispatch = useBackgroundDispatch()
  const {
    mutate: postAutomationRule,
    isPending,
    error,
  } = usePostAutomationRule()
  const { data: currentUser, isPending: currentUserInitialLoading } =
    useQueryOwnUser({})
  const userCanViewPage = !!currentUser?.hasOrgBookkeeperPermissions

  const onSuccessfulSubmit = (body: PostAutomationRuleRequest): void => {
    postAutomationRule(
      { body: body },
      { onSuccess: () => dispatch(closeModal()) },
    )
  }

  const imageSrc = useColorOrGrayscaleImage(ImageNames.CardTypeStandard)

  return (
    <RightFlyout width={RightFlyoutBodyWidths.Action}>
      {!userCanViewPage ? (
        <NotFoundRightFlyoutContent />
      ) : (
        <ActionRightFlyoutContent
          title={<Trns source={'Create Expense Category Rule'} />}
          specificElements={{
            imageSrc: imageSrc,
          }}
          pickerSubtitle={
            <Trns
              source={
                'Create a rule to automatically tag transactions with expense categories'
              }
            />
          }
        >
          {currentUserInitialLoading ? (
            <LoadingBackgroundPage />
          ) : (
            <AutomationRuleForm
              onSuccessfulSubmit={onSuccessfulSubmit}
              isPending={isPending}
              error={error}
              submitButtonContent={
                <div
                  css={css`
                    display: flex;
                    gap: 4px;
                  `}
                >
                  <SvgLightningBolt fill={styleConstants.colors.white} />
                  <Trns source={'Create Rule'} />
                </div>
              }
            />
          )}
        </ActionRightFlyoutContent>
      )}
    </RightFlyout>
  )
}

export default CreateAutomationRule
